import { UpdateTripTransportInput } from '@allocab/allocab-commons-shared-types';
import { TripOutput } from '@allocab/allocab-passenger-shared-types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { mutationKeys } from '../services/datastore/mutationKeys';
import { queryKeys } from '../services/datastore/queryKeys';
import { passengerApi } from '../services/network/Api';
import { APIError } from '../services/network/types';

const updateTransport = (input: UpdateTripTransportInput, key: string) =>
  passengerApi.patch<UpdateTripTransportInput, TripOutput>(`/trip/v1/${key}/update-transport`, input);

export const useUpdateTransport = (key: string) => {
  const queryClient = useQueryClient();
  const updateTransportMutation = useMutation<TripOutput, APIError, UpdateTripTransportInput>({
    mutationKey: mutationKeys.user.updateTransport(key),
    mutationFn: input => updateTransport(input, key),
    onSuccess: trip => {
      queryClient.setQueryData(queryKeys.user.fetchTrip(trip.key), trip);
    },
  });

  return updateTransportMutation;
};
